import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const CheckGreen: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--CheckGreen')}
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#00884F" fillRule="nonzero">
        <g>
          <path d="M12,3.5 C16.6944204,3.5 20.5,7.30557963 20.5,12 C20.5,16.6944204 16.6944204,20.5 12,20.5 C7.30557963,20.5 3.5,16.6944204 3.5,12 C3.5,7.30557963 7.30557963,3.5 12,3.5 Z M15.8633894,8 L10.412,13.647 L8.13661057,11.2893181 L7,12.4669886 L10.4098317,16 L10.544,15.86 L10.5477257,15.8630322 L17,9.17767046 L15.8633894,8 Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default CheckGreen;
